import axios from 'axios';
import VuexInstance from '../store/'

const token = localStorage.getItem('access_token') ? `Bearer ${localStorage.getItem('access_token')}` : ''

let axios_instance = axios.create({
    baseURL: VuexInstance.state.route_api_rest,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': token
    },
})


export default {

    async get(url) 
    {   
        return await axios_instance.get(url)
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async getWithoutAwait(url) 
    {   
        return axios_instance.get(url)
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async post(url, data, conf = {}) 
    {

        return await axios_instance.post(url, data, conf)
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data,
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async put(url, data) 
    {
        return await axios_instance.put(url, data)
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async patch(url, data) 
    {
        return await axios_instance.patch(url, data )
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async delete(url) 
    {
        return await axios_instance.delete(url)
            .then(response => ({
                status: true,
                number_status: response.status,
                data: response.data
            }))
            .catch(error => ({
                status: false,
                number_status: error.response ? error.response.status : error,
                data: error.response ? error.response.data : error.message
            }))
        
    },

    async createAxiosInstance(sent_token = null)
    {
        sent_token = sent_token ? sent_token : `${localStorage.getItem('access_token')}`
        axios_instance = axios.create({
                baseURL: VuexInstance.state.route_api_rest,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sent_token}`
                },
            })

    }

}